
import { GoTemplateDataRoot, IDisplayedProp } from "@/utils/go-template-data-structure/root";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";


export default Vue.extend({
	data() {
		return {
			value: null as null | IDisplayedProp
		};
	},
	props: {
		text: String,
		cursorPosition: Number,
		disabled: Boolean,
		isSubject: Boolean,
		data: Object as ()=> GoTemplateDataRoot
	},
	computed: {
		label():string{
			if (this.isSubject){
				return this.$ct("add-variable-to-subject").toString();
			}
			return this.$ct("add-variable").toString();
		},
		items():ISelectItem<IDisplayedProp>[] {
			return this.data.getDisplayedProperties(this.text, this.cursorPosition).filter(f=>{
				if (this.isSubject && f.value.type != "text"){
					return false;
				}
				return true;
			});
		},
	},
	methods: {
		add() {
			if (!this.value) return;
			if (this.value.type == "text") {
				this.$emit("add", this.value.value);
			}else if (this.value.type == "link"){
				this.$emit("add-link", this.value.value, this.value.args[0]);
			}else if (this.value.type == "image"){
				this.$emit("add-image", this.value.value);
			}
			this.value = null;
		},
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
